// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"280":"612d84a9","478":"a6a2c1c2","594":"58cc9f05"}[chunkId] + ".js";
};